module.exports = __webpack_public_path__ + "static/media/KaTeX_Size2-Regular.96a09bfe.woff2";